import { Star } from "lucide-react";

import { Reveal } from "@/components/site/reveal";

export function ReviewCard({
  quote,
  name,
  delay = 0,
}: {
  quote: string;
  name: string;
  delay?: number;
}) {
  return (
    <Reveal as="li" delay={delay}>
      <figure className="h-full rounded-3xl border border-border/70 bg-card p-8 shadow-[var(--shadow-soft)]">
        <div className="flex gap-1" role="img" aria-label="Five star rating">
          {Array.from({ length: 5 }).map((_, s) => (
            <Star key={s} className="size-4 fill-gold text-gold" aria-hidden="true" />
          ))}
        </div>
        <blockquote className="mt-5 font-display text-lg italic leading-snug">“{quote}”</blockquote>
        <figcaption className="mt-6 text-xs uppercase tracking-[0.18em] text-muted-foreground">
          {name}
        </figcaption>
      </figure>
    </Reveal>
  );
}
